import * as React from 'react';
import { DataCard } from './types';

type Props = {
  dataCard: DataCard;
};

const AiChatDataCard: React.FC<Props> = ({ dataCard }) => (
  <div className="ai-chat-data-card">
    <h4 className="ai-chat-data-card-title">{dataCard.title}</h4>
    <div>
      {dataCard.rows.map((row, idx) => (
        <div key={idx} className="ai-chat-data-card-row">
          <span className="ai-chat-data-card-label">{row.label}</span>
          <span
            className={`ai-chat-data-card-value${
              row.highlight ? ` ${row.highlight}` : ''
            }`}>
            {row.value}
          </span>
        </div>
      ))}
    </div>
  </div>
);

export default AiChatDataCard;
